/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_5Inputs */



/**
* | output |
* | --- |
* | "Enter the Machine ID and click Activate to generate an Activation Code" |
*
* @param {Login_Offline_Instruction_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_5 = /** @type {((inputs?: Login_Offline_Instruction_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez l'ID de Machine et cliquez sur Activer pour générer un Code d'Activation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie die Maschinen-ID ein und klicken Sie auf „Aktivieren“, um einen Aktivierungscode zu generieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci l'ID macchina e fai clic su Attiva per generare un codice di attivazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите идентификатор устройства и нажмите «Активировать», чтобы сгенерировать код активации.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese el ID de la máquina y haga clic en Activar para generar un código de activación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入机器 ID，然后单击“激活”以生成激活码。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マシンIDを入力し、「アクティベート」をクリックしてアクティベーションコードを生成します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मशीन आईडी दर्ज करें और एक्टिवेशन कोड जनरेट करने के लिए एक्टिवेट पर क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o ID da máquina e clique em Ativar para gerar um código de ativação.")
	return /** @type {LocalizedString} */ ("Enter the Machine ID and click Activate to generate an Activation Code")
});